import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemState extends Cloneable {
    static NONE = new ItemState(0, "NONE");

    static _values = [
        ItemState.NONE,
        new ItemState(1, "BUILD"),
        new ItemState(2, "MINE"),
        new ItemState(3, "HARVEST"),
        new ItemState(4, "REMOVE"),
        new ItemState(5, "READY")
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemState.getValue(id));
        });
    }

    static getValues() {
        return ItemState._values;
    }

    static getValue(id) {
        let value = ItemState._values.find(v => v.id === id) || null;
        console.assert(value, "unknown state id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemState) {
            return ItemState._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return ItemState.NONE.equal(value);
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemState) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemState());
        } else if (target instanceof ItemState) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemState, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});